// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import NutUI from '@nutui/nutui'
import Vuelidate from 'vuelidate'
import VueClipboard from 'vue-clipboard2'
import store from 'store/store'
import * as commonType from 'store/type';
import filter from 'filter/filter';
import directive from 'directive/directive';
import * as cartType from "store/cart/type";
import animated from 'animate.css';
import VueLazyload from 'vue-lazyload'
import share from 'common/js/share.min';
import * as nativeType from 'common/js/nativeType'

Vue.use(NutUI)
Vue.use(Vuelidate)
Vue.use(VueClipboard)
Vue.use(animated)
Vue.use(VueLazyload, {
    error:"common/img/error-jd.gif",
})

//common抽离出来，原因：放配置文件里面读取图片路径有报错
import 'common/css/common.scss'
//字体文件只能在业务中引入
import 'common/css/iconfont.scss'
// import 'common/css/plugin.scss'
import util from 'common/js/util';
import Qs from 'qs'
import global from 'common/js/global';

util.setRootFont(); //设置根元素字体大小

Vue.config.productionTip = false
Vue.prototype.GLOBAL_CFG = global;
Vue.prototype.nativeType = nativeType

/**
 * 主站：
 * //img10.360buyimg.com
 * //img11.360buyimg.com
 * //img12.360buyimg.com
 * //img13.360buyimg.com
 * //img14.360buyimg.com
 * //img20.360buyimg.com
 * //img30.360buyimg.com
 * 移动端：
 * //m.360buyimg.com
 */
const imgDomains = ["//m.360buyimg.com"];

const mixins = {
    /*
    * 一级相关页面跳转逻辑，包括一级跳二级、一级跳一级、二级跳一级
    * pageObj对象字段
    *    pageName：String 页面路由name
    *    queryParamObj：Object 页面路由参数，没有参数传null或不传
    *    toFirstPage： Boolean 跳转到一级页面（包括一级跳一级和二级跳一级），不传表示跳转到二级页面
    *    jumpUrl: String 要跳转的URL 一级跳二级页面优先使用此URL跳转，如首页的轮播图
    * */
    firstPageJump({pageName,queryParamObj,toFirstPage,jumpUrl}){
        const verInfo = this.$store.state.appVerInfo;
        let verCode = verInfo.verCode;
        if(util.isAndroid()){
            verCode = Number.parseInt(verInfo.verCode);
            if(verCode >= 7){ //1.0.8版本及以上，包括1.0.8
                this.newPageJump(pageName,queryParamObj,toFirstPage,jumpUrl);
            }else{
                this.h5PageJump(pageName,queryParamObj,jumpUrl);
            }
        }else if(util.isIOS()){
            if(this.GLOBAL_CFG.LOGIN_TYPE === 5) { //电脑浏览器跳转
                this.h5PageJump(pageName,queryParamObj,jumpUrl);
            }else {
                this.newPageJump(pageName,queryParamObj,toFirstPage,jumpUrl);
            }
        }
    },
    //h5页面之间跳转
    h5PageJump(pageName,queryParamObj,jumpUrl){
        if(jumpUrl){
            window.location.href = jumpUrl;
        }else{
            if(pageName === 'homePage'){ //首页
                this.$router.push('/');
            }else{
                this.$router.push({
                    path: `/${pageName}`,
                    // name: pageName,
                    query:queryParamObj
                });
            }
        }
    },
    //h5和原生互相跳转
    newPageJump(pageName,queryParamObj,toFirstPage,jumpUrl){
        if(this.GLOBAL_CFG.LOGIN_TYPE === 5){ //电脑浏览器跳转
            this.h5PageJump(pageName,queryParamObj);
        }else{ //跟原生交互 一级跳二级或一级跳一级（手机）
            let params = '';
            if(queryParamObj){
                params = `?${Qs.stringify(queryParamObj)}`;
            }
            if(toFirstPage){ //跳一级页面
                if(pageName === 'homePage'){ //首页
                    util.jumpToRN(pageName, "", {url: `${this.GLOBAL_CFG.PAGE_CONFIG[process.env.BUILD_ENV]}/#/`});
                }else{
                    util.jumpToRN(pageName, "", {url: `${this.GLOBAL_CFG.PAGE_CONFIG[process.env.BUILD_ENV]}/#/${pageName}${params}`});
                }
            }else{ //跳二级页面
                if(jumpUrl){
                    util.jumpToRN('subPage', "", {url: jumpUrl});
                }else{
                    util.jumpToRN('subPage', "", {url: `${this.GLOBAL_CFG.PAGE_CONFIG[process.env.BUILD_ENV]}/#/${pageName}${params}`});
                }
            }
        }
    },
    //跳转二级原生页面 包括二级跳二级h5 一级跳二级原生 一级跳二级h5
    // 1.1.4版本以上跳原生
    // moduleName 模块名
    // queryParamObj 页面参数
    // androidVer android页面原生化的上一个版本，如1.1.4是12
    // iosVer iOS页面原生化的上一个版本，如1.1.4是114
    // srcIsFirstPage 来源页面是否是一级页面，兼容我的产品线跳商详页、个人中心跳订单采购单情况，默认是false
    jumpSubNativePage({pageName, queryParamObj, androidVer, iosVer, srcIsFirstPage}){
        //二级原生页面跟h5页面的对应关系
        const pageObj = {
            productDetail: 'openProductDetail',
            myOrder: 'openOrderList',
            purchaseOrder: 'openPurchaseOrderList',
            shoppingCart: 'openMiniShoppingCart'
        };
        if(this.GLOBAL_CFG.LOGIN_TYPE === 5) { //电脑浏览器跳转
            this.h5PageJump(pageName,queryParamObj);
        }else if(this.isClientVersionHigher({androidVerCode: androidVer, iosVerCode: iosVer})){ //最新版本，比如商品详情页原生化后的1.1.6版本
            util.jumpToRN(pageObj[pageName] || '', '', queryParamObj);
        }else if(srcIsFirstPage){ //来源页面是一级页面，兼容我的产品线跳商详页情况 兼容<1.0.8, 1.0.8-1.1.4
            // 我的产品线=托盘首页
            this.firstPageJump({
                pageName,
                queryParamObj
            });
        }else{
            this.h5PageJump(pageName,queryParamObj);
        }
    },
    // 跳转到商品详情页 商品详情页在1.1.4以上版本开始原生化
    jumpProductDetail(queryParamObj, srcIsFirstPage){
        this.jumpSubNativePage({
            pageName: 'productDetail',
            queryParamObj,
            androidVer: 12, //android的1.1.4版本
            iosVer: 114,
            srcIsFirstPage
        });
    },
    // 跳转到迷你购物车页
    jumpMiniShoppingCart(queryParamObj={ isMini: true }, srcIsFirstPage=false){
        this.jumpSubNativePage({
            pageName: 'shoppingCart',
            queryParamObj,
            androidVer: 20, //android的2.1.2版本 20201123
            iosVer: 212,
            srcIsFirstPage
        });
    },
    abnormalQualificationJump(){
        let state = this.$store.state.userState;
        let tipStr = '';
        switch(state){
            case 2:
                tipStr = '您好，您的资质正在审核中，请耐心等待。';
                this.$toast(tipStr, 3000);
                break;
            case 3:
                tipStr = '抱歉，您的资质未通过审核，即将跳转到资质修改页面';
                this.$toast(tipStr, 3000);
                setTimeout(()=>{
                    this.firstPageJump({
                        pageName: 'register'
                    });
                },1500);
                break;
        }
    },
    //客户端是否是1.0.6版本及以上
    is106orHigher(){
        const verInfo = this.$store.state.appVerInfo;
        let verCode = verInfo.verCode;
        let flag = false;
        if(util.isAndroid()){
            verCode = Number.parseInt(verInfo.verCode);
            if(verCode >= 6){ //1.0.6版本及以上，包括1.0.6
                flag = true;
            }else{
                flag = false;
            }
        }else if(util.isIOS()){
            // 目前的版本都是大于1.0.6的，除了本地测试，都返回true
            if(this.GLOBAL_CFG.LOGIN_TYPE === 5) {
                flag = false;
            }else {
                flag = true;
            }
        }
        return flag;
    },
    //客户端版本是某个版本以上，不包括当前版本 使用version替换build，此方法修改函数名并弃用
    // 客户端版本对象 iosVerCode，包含下面2个信息
    //androidVerCode Android版本号
    //iosVerCode iOS版本号
    isClientVersionHigherOld(verCodeObj){
        const verInfo = this.$store.state.appVerInfo;
        const verCode = Number.parseInt(verInfo.verCode);
        let flag = false;
        if(util.isAndroid()){
            if(verCode > verCodeObj.androidVerCode){ //比如1.0.6版本以上，verCodeObj.androidVerCode为6
                flag = true;
            }else{
                flag = false;
            }
        }else if(util.isIOS()){
            /*alert('current version：'+verCode);
            alert('109:'+this.GLOBAL_CFG.IOS_VERSIONS[verCodeObj.iosVerCode]);
            alert('比较：'+(verCode > this.GLOBAL_CFG.IOS_VERSIONS[verCodeObj.iosVerCode]));*/
            if(verCode > this.GLOBAL_CFG.IOS_VERSIONS[verCodeObj.iosVerCode]){ //比如1.0.6版本以上，verCodeObj.iosVerCode为106
                flag = true;
            }else{
                flag = false;
            }
        }
        return flag;
    },

    /**
     * 客户端版本是某个版本以上，不包括当前版本 适用于使用version判断版本号场景，不兼容老版本build字段的情况
     * @param verCodeObj 客户端版本对象  例子：{androidVerCode: 12, iosVerCode: '3.0.1'}
     * verCodeObj包含androidVerCode Android版本号； iosVerCode iOS版本号
     * @returns {boolean}
     */
    isClientVersionHigher(verCodeObj){
        const verInfo = this.$store.state.appVerInfo;
        let verCode = verInfo.verCode;
        let flag = false;
        if(util.isAndroid()){
            verCode = Number.parseInt(verInfo.verCode);
            if(verCode > verCodeObj.androidVerCode){ //比如1.0.6版本以上，verCodeObj.androidVerCode为6
                flag = true;
            }else{
                flag = false;
            }
        }else if(util.isIOS()){
            //业务老代码兼容的是build值，传过来的是整数，老版本不再做业务兼容，一律认为当前版本大于之前的版本；
            if(typeof verCodeObj.iosVerCode == "number") {
                flag = true;
            }else if(util.isNewIosVersionHigher(verCode, verCodeObj.iosVerCode)){ // 当前版本大于要比较的版本
                flag = true;
            }else {
                flag = false;
            }
        }
        return flag;
    },
    //解密手机号码
    //encodePhone 加密的手机号
    decodePhoneFn(encodePhone){
        let decodePhone = '';
        if(util.isAndroid()){
            decodePhone = window.Android.decodeAES("JINGDONGWANSHANG", encodePhone);
        }else if(util.isIOS()){
            if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getVersionInfo && window.webkit.messageHandlers.getVersionInfo.postMessage) {
                // 去掉是否大于等于'1.0.6'的判断
                window.checkPhoneFn = (res) => {
                    if (res && typeof res === 'string') {
                        this.$store.commit(commonType.SET_IOS_DECODE_PHONE, res);
                    }
                };
                window.webkit.messageHandlers.decodePhoneNum.postMessage(String(encodePhone));
            } else {
                window.postMessage("phone," + encodePhone);
            }
        }
        return decodePhone;
    },
    isWeixinBrowser(){
        let ua = navigator.userAgent.toLowerCase();
        let isWeixin = ua.indexOf('micromessenger') != -1;
        if (isWeixin) {
            return true;
        }else{
            return false;
        }
    },
    isQQ(){
        // let u = navigator.userAgent;
        let ua = navigator.userAgent.toLowerCase();
        let isQQ = ua.match(/QQ/i) == "qq" ? true : false;   //QQ内置浏览器
        // let isQQbrw = u.indexOf('MQQBrowser') > -1;       //QQ浏览器
        return isQQ;
    },
    getWeixinAuthorizeUrl(orderId){
        let returnUri = this.getPageDomain() + "#/weixinPay?orderId=" + orderId;
        let appid= "wxcd6ec611fa73744e";//线上：wxcd6ec611fa73744e  测试号：wx00cfcd171d1b30a3
        return "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+appid+"&redirect_uri="+encodeURIComponent(returnUri)+"&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
    },
    shareUrl(title, desc, iconUrl) {
        let shareOption = {
            iconUrl: iconUrl || require('./common/img/share-logo.png'),
            url: location.href,
            title: title || '京东万商平台',
            desc: desc || '优质货源，尽在京东万商'
        };

        try {
            /*初始化分享*/
            window.share.shareInit(shareOption);
        } catch (e) {
            console.log(e);
        }
    },
    getPageDomain(){
        let href = location.href;
        let host = href.split("#")[0];
        //let notLoginAddress = host+'#/notLogin';
        return host;
    },
    //动态取图片地址参数
    getImageDomains() {
        return imgDomains;
    },
    getImageDomain() {
        if (imgDomains) {
            return imgDomains[Math.floor(Math.random() * (imgDomains.length - 1))];
        }
        return imgDomains;
    },
    getImagePath(n, imageRelativePath) {
        return this.getImageQPath(n, imageRelativePath, null);
    },
    //safira浏览器不支持webp格式，暂时不处理此格式
    getImageQPath(n, imageRelativePath, q) {
        if(imageRelativePath){
            n = "/n" + (n || 1);
            imageRelativePath = imageRelativePath || require('./common/img/error-jd.gif');
            if(imageRelativePath.toLowerCase().indexOf("http") == 0 || imageRelativePath.indexOf("//") == 0){
                return imageRelativePath + ".dpg";
            }
            if (imageRelativePath.indexOf("/") != 0) {
                n += "/";
            }
            if (q) {
                q = ("!q" + q);
            } else {
                q = "";
            }
            return this.getImageDomain() + n + imageRelativePath + q + ".dpg";
        }
        return '';
    },
    /*width 图片的宽度
    height 图片的高度*/
    getImageQPathNew(width, height, imageRelativePath, q) {
        if(imageRelativePath){
            if(imageRelativePath.toLowerCase().indexOf("http") == 0 || imageRelativePath.indexOf("//") == 0){
                return imageRelativePath + ".dpg";
            }
            let size = '';
            if (imageRelativePath.indexOf("/") != 0 && width && height) {
                size = '/s' + width + 'x' + height + '_';
            }
            if (q) {
                q = ("!q" + q);
            } else {
                q = "";
            }
            return this.getImageDomain() + '/fenxiaom' + size + imageRelativePath + q + ".dpg";
        }
        return '';
    },
    getImagePathHttp(n, imageRelativePath) {
        if (imageRelativePath) {
            let imagePath = this.getImagePath(n, imageRelativePath);
            if (imagePath.indexOf("//") == 0) {
                return "http:" + imagePath;
            } else if (imagePath.toLowerCase().indexOf("https://") == 0) {
                return imagePath.replace(/https:/i, "http:");
            } else if (imagePath.toLowerCase().indexOf("http://") == 0) {
                return imagePath;
            } else if (imagePath.toLowerCase().indexOf("/") == 0) {
                return "http:/" + imagePath;
            } else {
                return "http://" + imagePath;
            }
        }
        return null;
    },
    getImagePathHttps(n, imageRelativePath) {
        if (imageRelativePath) {
            return this.getImagePathHttp(n, imageRelativePath).replace(/http:/i, "https:");
        }
        return null;
    },
    dispachNativeAction(type) {
        switch (type) {
            case this.nativeType.MYBEAN.iconType:
                this.$router.push('/beanPolicy')
                break
            case this.nativeType.MYBEAN.textType:
                this.$router.push('/beanDetail')
                break
        }
    },
    setNativeHeader(headerOptions) {
        const { iconType, textType, text, iosIconName } = headerOptions
        if (util.isAndroid()) {
            util.jumpToRN('setTitleRightIconAndRightView', '', {
                iconType: iconType,
                textType: textType,
                text: text,
            })
        } else if (util.isIOS()) {
            const setIconData = {
                type: iconType,
                text: iosIconName,
            }
            const setTextData = {
                type: textType,
                text: text,
            }
            window.webkit.messageHandlers.setTopBarTitleIcon.postMessage(JSON.stringify(setIconData))
            window.webkit.messageHandlers.setTopBarRightButton.postMessage(JSON.stringify(setTextData))
        }
    }
}

Object.assign(Vue.prototype, mixins)

Object.keys(filter).forEach(key => Vue.filter(key, filter[key]));

Object.keys(directive).forEach(key => Vue.directive(util.camelToLine(key), directive[key]));

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    created(){
        window.nativeTopBarIconButtonAction = (type) => {
            this.dispachNativeAction(type)
        }

        window.nativeTopBarRightButtonAction = (type) => {
            this.dispachNativeAction(type)
        }
        util.getAppVersion((verInfo)=>{
            this.$store.commit(commonType.SET_APP_VER_INFO, verInfo);
        });

        if(util.isIOS()){
            util.getDarkMode((mode) => {
                this.$store.commit(commonType.SET_DARK_MODE, mode);
            });
        }
    },
    mounted:function(){
        //默认分享
        this.shareUrl('京东分销平台诚邀您加入', '即刻注册，海量优质货源，\n' + '众多正品渠道，等您来挑选>>', require('./common/img/share-logo.png'));

        document.addEventListener('message', (res) => {
            if (util.isIOS()) {
                if (res.data && res.data.split(',')[0] && res.data.split(',')[0].toString() == 'phone') {
                    this.$store.commit(commonType.SET_IOS_DECODE_PHONE, res.data.split(",")[1]);
                }
            }
        });
    }
});

//手机/平板禁止横屏
(function rotate(){
    var orientation=window.orientation;
    var pd = null;
    function createPd(){
        if(document.getElementById('preventTran') === null){
            var imgData = 'data:image/png;base64,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';
            pd = document.createElement('div');
            pd.setAttribute('id','preventTran');
            pd.style.position = 'fixed';
            pd.style.left = '0';
            pd.style.top = '0';
            pd.style.width = '100%';
            pd.style.height = '100%';
            pd.style.overflow = 'hidden';
            pd.style.backgroundColor = '#2e2e2e';
            pd.style.textAlign = 'center';
            pd.style.zIndex = '99999';
            document.getElementsByTagName('body')[0].appendChild(pd);
            var img = document.createElement('img');
            img.src = imgData;
            pd.appendChild(img);
            img.style.margin = '60px auto 30px'
            var br = document.createElement('br');
            var p = document.createElement('p');
            p.style.width = '100%';
            p.style.height = 'auto';
            p.style.fontSize = '22px';
            p.style.color = '#626262';
            p.style.lineHeight = '34px';
            p.style.textAlign = 'center';
            p.innerHTML = '为了您的良好体验';
            p.appendChild(br);
            p.innerHTML += '请将手机/平板竖屏操作';
            pd.appendChild(p);
        }
    }
    if(orientation==90||orientation==-90){
        if(pd == null && document.getElementById('preventTran') === null) createPd();
        document.getElementById('preventTran').style.display = 'block';
    }
    window.onorientationchange=function(){
        if(pd == null && document.getElementById('preventTran') == null) createPd();
        document.getElementById('preventTran').style.display='none';
        rotate();
    };
})();




// WEBPACK FOOTER //
// ./src/main.js